import { T } from '@tolgee/react';

import theme from '../../../assets/theme';
import { MaterialAttachment } from '../../../hooks/useUploadMaterialAttachment';
import { Button } from '../../_atoms/Button';
import BaseModal from '../../_molecules/BaseModal';
import GameImageRenderer from '../../_molecules/GameImageRenderer';
import { TextFileRendererLargePreview } from '../../_molecules/GameImageRenderer/GameImageRenderer';

export function MaterialAttachmentPreview({
  isAttachmentPreviewOpen,
  setIsAttachmentPreviewOpen,
  selectedAttachment,
}: {
  isAttachmentPreviewOpen: boolean;
  setIsAttachmentPreviewOpen: (isOpen: boolean) => void;
  selectedAttachment: MaterialAttachment | undefined;
}) {
  return (
    <BaseModal
      visible={isAttachmentPreviewOpen}
      hideCancel={true}
      onCancel={() => setIsAttachmentPreviewOpen(false)}
      width="800px"
    >
      <div style={{ display: 'grid', gap: 16 }}>
        <div style={{ width: '100%', height: '100%' }}>
          {selectedAttachment?.mimetype?.startsWith('image/') &&
            selectedAttachment?.fileId && (
              <GameImageRenderer
                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                fileId={selectedAttachment.fileId}
                fileMimetype={selectedAttachment.mimetype}
                fileAltText={selectedAttachment.fileName || ''}
                isDiscoverTemplate={false}
                isAuthenticated={true}
                isOwner={true}
              />
            )}
          {selectedAttachment?.mimetype === 'text/plain' && selectedAttachment?.fileId && (
            <div
              style={{
                width: '100%',
                maxHeight: '60vh',
                overflowY: 'auto',
                border: `1px solid ${theme.colors.grey}`,
                borderRadius: 8,
                padding: 12,
                background: theme.colors.white,
              }}
            >
              <TextFileRendererLargePreview fileId={selectedAttachment.fileId} />
            </div>
          )}
          {selectedAttachment &&
            selectedAttachment.mimetype !== 'text/plain' &&
            !selectedAttachment.mimetype.startsWith('image/') && (
              <div
                style={{
                  width: '100%',
                  padding: 16,
                  border: `1px solid ${theme.colors.grey}`,
                  borderRadius: 8,
                  background: theme.colors.white,
                }}
              >
                <div style={{ fontWeight: 600 }}>{selectedAttachment.fileName}</div>
                <div style={{ color: theme.colors.greyDark, marginTop: 8 }}>
                  <T
                    keyName="ObjectiveRefinement.AttachmentPreviewModal.PreviewNotAvailable"
                    defaultValue="Preview not available for this file type."
                  />
                </div>
              </div>
            )}
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            onClick={() => setIsAttachmentPreviewOpen(false)}
            styles={{
              backgroundColor: 'transparent',
              color: theme.colors.greyDark,
              border: `1px solid ${theme.colors.grey}`,
              padding: '10px 20px',
              borderRadius: '8px',
              fontWeight: 600,
            }}
          >
            <T
              keyName="ObjectiveRefinement.AttachmentPreviewModal.CloseButtonText"
              defaultValue="Close"
            />
          </Button>
        </div>
      </div>
    </BaseModal>
  );
}
